const clean = (hook = "") =>
  String(hook)
    .replace(/\s+/g, " ")
    .replace(/["'\u2018\u2019\u201C\u201D]/g, "")
    .trim();

// Display title for LinkedIn. Printed verbatim in the feed next to the
// page count, so: no prefix, no file extension.
export const mediaTitleFrom = (hook = "") => {
  const text = clean(hook);
  if (!text) return "Carousel";
  return text.length <= 120 ? text : text.slice(0, 120).trimEnd();
};

// For titles that come from an uploaded file rather than a hook.
// Drops the extension and tidies dots/underscores.
export const titleFromFilename = (name = "") =>
  mediaTitleFrom(
    String(name)
      .replace(/\.[a-z0-9]{1,6}$/i, "")
      .replace(/[._]+/g, " ")
  );

// Filename for a local download. Keeps prefix and extension, and strips
// characters that are illegal in filenames.
export const mediaFilenameFrom = (
  hook = "",
  { prefix = "Presentation", ext = "pdf" } = {}
) => {
  const text = clean(hook)
    .replace(/[\\/:*?"<>|]/g, "")
    .slice(0, 60)
    .trim();
  const stem = [prefix, text].filter(Boolean).join(" ").trim() || "Download";
  return `${stem}.${ext}`;
};